slideAnime = (() => {
    let e = !1;
    return t => {
        const n = Object.assign({}, {
                target: !1,
                animeType: "slideToggle",
                duration: 400,
                easing: "ease",
                isDisplayStyle: "block"
            }, t),
            o = n.target;
        if (!o) return;
        if (e) return;
        e = !0;
        let i = n.animeType;
        const s = getComputedStyle(o);
        if ("slideToggle" === i && (i = "none" === s.display ? "slideDown" : "slideUp"), "slideUp" === i && "none" === s.display || "slideDown" === i && "none" !== s.display || "slideUp" !== i && "slideDown" !== i) return e = !1, !1;
        o.style.overflow = "hidden";
        const l = n.duration,
            r = n.easing,
            a = n.isDisplayStyle;
        "slideDown" === i && (o.style.display = a);
        const c = {
            height: o.getBoundingClientRect().height + "px",
            marginTop: s.marginTop,
            marginBottom: s.marginBottom,
            paddingTop: s.paddingTop,
            paddingBottom: s.paddingBottom
        };
        if (Object.keys(c).forEach((e => {
                0 === parseFloat(c[e]) && delete c[e]
            })), 0 === Object.keys(c).length) return e = !1, !1;
        let d;
        "slideDown" === i ? (Object.keys(c).forEach((e => {
            o.style[e] = 0
        })), d = o.animate(c, {
            duration: l,
            easing: r
        })) : "slideUp" === i && (Object.keys(c).forEach((e => {
            o.style[e] = c[e], c[e] = 0
        })), d = o.animate(c, {
            duration: l,
            easing: r
        })), d.finished.then((() => {
            o.style.overflow = "", Object.keys(c).forEach((e => {
                o.style[e] = ""
            })), "slideUp" === i && (o.style.display = "none"), e = !1
        }))
    }
})();


var TwaSettingsSwiper = {
    init: function() {
        this.TwaSettingsCarousel();
    },
    TwaSettingsCarousel: function() {
        document.querySelectorAll(".twa__swiper").forEach((e => {
            this.TwaCarousel(e);
        }))
    },
    TwaCarousel: function(e) {
        var t = "true" === e?.dataset.autoplay,
            n = "true" === e.dataset.loop,
            w = e?.dataset.rows ? e?.dataset.row : 1,
            o = e?.dataset.slideshow ? e?.dataset.slideshow : 0,
            pgm = e?.dataset.spgmobile ? e?.dataset.spgmobile : 1,
            pgt = e?.dataset.spgtablet ? e?.dataset.spgtablet : 1,
            pgd = e?.dataset.spgdesktop ? e?.dataset.spgdesktop : 1,
            i = e?.dataset.desktop ? e?.dataset.desktop : 4,
            s = e?.dataset.tablet ? e?.dataset.tablet : 2,
            r = e?.dataset.mobile ? e?.dataset.mobile : 1,
            a = e?.dataset.autoplaySpeed ? e?.dataset.autoplaySpeed : 3e3,
            c = e?.dataset.speed ? e?.dataset.speed : 400,
            l = e?.dataset.effect ? e?.dataset.effect : "slide",
            d = e?.dataset.sectionId,
            u = e?.dataset.row ? e?.dataset.row : 1,
            ut = e?.dataset.rowtablet ? e?.dataset.rowtablet : 1,
            um = e?.dataset.rowmobile ? e?.dataset.rowmobile : 1,
            p = window.innerWidth,
            m = e?.dataset.spacing ? e?.dataset.spacing : 0;
            cs = "true" === e.dataset.centerslide, 
            pg_number = e?.dataset.ctpagination ? e?.dataset.ctpagination : "swiper-pagination",
            desktop = parseInt(pgd);
            tablet = parseInt(pgt);
            mobile = parseInt(pgm);
            console.log(pg_number);
            al = e?.dataset.arrowleft ? e?.dataset.arrowleft : "swiper-button-prev",
            ar = e?.dataset.arrowright ? e?.dataset.arrowright : "swiper-button-next",
            m = Number(m), a = Number(a), c = Number(c), p <= 767 ? m >= 15 && (m = 15) : p <= 1199 && m >= 30 && (m = 30), new Swiper("#twa__swiper-" + d, {
              
            slidesPerView: r,
            slidesPerColumn: w,
            slidesPerGroup: mobile, 
            spaceBetween: m,
            centeredSlides: cs,
            
            autoplay: t,
            delay: a,
            loop: n,
            effect: l,
            speed: c,
            watchSlidesProgress: !0,
            watchSlidesVisibility: !0,
            draggable: true,
            grid: {
                rows: um,
                fill: "row"
            },
            // navigation: {
            //     nextEl: e.querySelector(`.${ar}`),
            //     prevEl: e.querySelector(`.${al}`)
            // },
            navigation: {
              nextEl: `.${ar}`,
              prevEl: `.${al}`,
            },
            pagination: {
                clickable: !0,
                //el: e.querySelector(`.${pg_number}`)
                el:`.${pg_number}`
            },
            breakpoints: {
                768: {
                    slidesPerView: s,
                    centeredSlides: cs,
                    slidesPerGroup: tablet,
                    grid: {
                      rows: ut,
                      fill: "row"
                    }
                },
                1450: {
                    slidesPerView: i,
                    slidesPerGroup: desktop,
                    grid: {
                      rows: u, 
                      fill: "row"
                    }
                    //centeredSlides: cs,
                }
            }
        })
    }
  };
  TwaSettingsSwiper.init();
  document.addEventListener("shopify:section:load", function(event) {
    TwaSettingsSwiper.init();
  });



  var BlsToggle = {
    init: function() {
        this.initToggle()
    },
    initToggle: function() {
        document.querySelectorAll(".dtx__page-faq-items > .dtx__page-faq-title").forEach((e => {
            e.addEventListener("click", (t => {
                t.preventDefault();
                const n = t.currentTarget.parentElement.querySelector(".dtx__page-faq-content");
                slideAnime({
                    target: n,
                    animeType: "slideToggle"
                }), e.closest(".dtx-toggle").classList.contains("active") ? e.closest(".dtx-toggle").classList.remove("active") : e.closest(".dtx-toggle").classList.add("active")
            }))
        }))
    }
};
BlsToggle.init();


var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})

function videoWrapper(){
    if (typeof videojs === "undefined") {
        console.error("Video.js library failed to load.");
        return;
    }
    document.querySelectorAll('.video-js').forEach(video => {
        videojs(video.id, {
            controls: true,
            //autoplay: 'muted',
            autoplay: false,
            loop: true,
            fluid: true,
            playbackRates: [0.5, 1, 1.5, 2],
            responsive: true
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    videoWrapper();
});
document.addEventListener("shopify:section:load", function() {
    videoWrapper();
});

var BlsEventMainProductShopify = {
    init: function() {
        this.eventMediaGalleryProduct()
    },
    eventMediaGalleryProduct: function() {
        const e = document.querySelector(".bls__swiper-gallery-thumbnails"),
            t = document.querySelector(".bls__swiper-gallery");
        if (e)
            // if (e.classList.contains("bls__swiper-vertical")) var r = new Swiper(".bls__swiper-gallery-thumbnails.bls__swiper-vertical", {
            //     spaceBetween: 10,
            //     slidesPerView: 8,
            //     freeMode: !0,
            //     direction: "vertical",
            //     watchSlidesProgress: !0
            // });
            //else 
            r = new Swiper(".bls__swiper-gallery-thumbnails", {
                spaceBetween: 8,
                slidesPerView: 'auto',
                freeMode: !0,
                watchSlidesProgress: !0,
                navigation: {
                    nextEl: ".swiper-next",
                    prevEl: ".swiper-prev"
                }
            });
        if (t)
            if (r) var o = new Swiper(".bls__swiper-gallery", {
                loop: !1,
                speed: 600,
                navigation: {
                    nextEl: ".swiper-next",
                    prevEl: ".swiper-prev"
                },
                thumbs: {
                    swiper: r
                }
            });
            else {
                const e = "true" === t.dataset.autoplay,
                    r = t?.dataset.mobile,
                    i = t?.dataset.spacing,
                    a = t?.dataset.sectionId;
                o = new Swiper(".bls__swiper-gallery", {
                    slidesPerView: r,
                    spaceBetween: Number(i),
                    autoplay: e,
                    speed: 600,
                    loop: !1,
                    grid: {
                        rows: a
                    },
                    navigation: {
                        nextEl: ".swiper-next",
                        prevEl: ".swiper-prev"
                    },
                    pagination: {
                        clickable: !0,
                        el: ".swiper-pagination"
                    }
                })
            } 
            
    }
};
BlsEventMainProductShopify.init();